"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDatePluginInfo = exports.isDatePluginAvailable = exports.DatePlugin = void 0;
let dayjs = null;
try {
    dayjs = require('dayjs');
    const utc = require('dayjs/plugin/utc');
    dayjs.extend(utc);
}
catch (_a) {
    // dayjs not available
}
exports.DatePlugin = {
    name: 'date',
    operators: ['$after', '$before'],
    testExpression(data, exp) {
        if (!dayjs) {
            throw new Error('Date plugin requires dayjs dependency. Install dayjs: npm install dayjs');
        }
        if (!Array.isArray(exp) || !this.operators.includes(exp[1])) {
            return null; // Not handled by this plugin
        }
        const [value, operator, options] = exp;
        switch (operator) {
            case "$after":
                if (!dayjs.isDayjs(data) && typeof data !== "string") {
                    return false;
                }
                if (!dayjs(data).isValid()) {
                    return false;
                }
                if (typeof value !== "number") {
                    return false;
                }
                return dayjs(data).isAfter(dayjs().utc().add(value, options));
            case "$before":
                if (!dayjs.isDayjs(data) && typeof data !== "string") {
                    return false;
                }
                if (!dayjs(data).isValid()) {
                    return false;
                }
                if (typeof value !== "number") {
                    return false;
                }
                return dayjs(data).isBefore(dayjs().utc().add(value, options));
            default:
                return null;
        }
    }
};
const isDatePluginAvailable = () => {
    return dayjs !== null;
};
exports.isDatePluginAvailable = isDatePluginAvailable;
const getDatePluginInfo = () => {
    return {
        available: (0, exports.isDatePluginAvailable)(),
        operators: exports.DatePlugin.operators,
        version: dayjs ? 'detected' : 'not available'
    };
};
exports.getDatePluginInfo = getDatePluginInfo;
//# sourceMappingURL=date-plugin.js.map